import type { TRuleWithTheme } from 'styles/theme';

import { AssistantMode } from '../../types';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
});

export const questionRow: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    fontSize: '0.8125rem',
});

export const question: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.text,
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.35,
    marginTop: '0.25rem',
});

export const tagRow: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});

export const modeTag: TRuleWithTheme<{ mode: AssistantMode }> = ({ theme, mode }) => ({
    '&.ant-tag': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.375rem',
        borderRadius: '999px',
        border: 'none',
        padding: '0.125rem 0.625rem',
        fontWeight: 600,
        color: mode === AssistantMode.SQL ? theme.colors.statusInfo : theme.colors.darkGreen,
        backgroundColor: mode === AssistantMode.SQL ? theme.colors.bgStatusInfo : theme.colors.bgStatusSuccess,
    },
});

export const answer: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.text,
    fontSize: '1rem',
    lineHeight: 1.65,
    whiteSpace: 'pre-line',
});

export const meta: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    fontSize: '0.75rem',
});

export const skeletonWrapper: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
});
